export enum UnitDocumentType {
    /** Not a real status in Unit */
    None = 0,
    IdDocument = 1,
    Passport = 2,
    AddressVerification = 3,
    SocialSecurityCard = 4,
    CertificateOfIncorporation = 5,
    EmployerIdentificationNumberConfirmation = 6
}

// tslint:disable-next-line:no-namespace
export namespace UnitDocumentType {
  export function toString(enumValue: UnitDocumentType): string {
    switch (enumValue) {
      case UnitDocumentType.None:
        return null;
      case UnitDocumentType.IdDocument:
        return "ID Document";
      case UnitDocumentType.Passport:
        return "Passport";
      case UnitDocumentType.AddressVerification:
        return "Address Verification";
      case UnitDocumentType.SocialSecurityCard:
        return "Social Security Card";
      case UnitDocumentType.CertificateOfIncorporation:
        return "Certificate of Incorporation";
      case UnitDocumentType.EmployerIdentificationNumberConfirmation:
        return "Employer Identification Number Confirmation";
      default:
        return null;
    }
  }

  export function listAll() {
    return [
      UnitDocumentType.IdDocument,
      UnitDocumentType.IdDocument,
      UnitDocumentType.Passport,
      UnitDocumentType.AddressVerification,
      UnitDocumentType.SocialSecurityCard,
      UnitDocumentType.CertificateOfIncorporation,
      UnitDocumentType.EmployerIdentificationNumberConfirmation,
    ];
  }

  export function parse(str: string): UnitDocumentType {
    return UnitDocumentType[str];
  }
}

export default UnitDocumentType;
